module.exports = __webpack_public_path__ + "img/clock-rotate-left.07093f6d.svg";